import { KeyValue } from '@api';
import { WithNAFallback } from '@design';
import clsx from 'clsx';
import React from 'react';

import styles from './KeyValueElement.module.scss';

export interface KeyValueElementProps {
  keyValue: KeyValue;
  isDefaultVariant?: boolean;
}

export const KeyValueElement = ({
  keyValue,
  isDefaultVariant = true,
}: KeyValueElementProps) => {
  return (
    <div
      className={clsx(styles.keyValueElementRoot, {
        [styles.defaultVariant]: isDefaultVariant,
      })}
      data-testid="components"
    >
      <div className={styles.title}>{keyValue.display}</div>
      <div className={styles.details}>
        <span className={styles.value}>
          <WithNAFallback
            check={keyValue.value_fmt !== undefined}
            value={keyValue.value_fmt}
          />
        </span>
        {keyValue.value_fmt && (
          <span className={styles.unit}>{keyValue.unit}</span>
        )}
      </div>
    </div>
  );
};
